import { defined, present } from 'shared/presenters/presenter'
import { SidebarNavList, SidebarNavListItem } from 'enums/sidebar'

/**
 * We are not using the Sidebar provided by "graphqlTypes" because it only returns a JSON
 * as "items: Scalars['json']", which doesn't have a type declaration.
 *
 * This is a special case because it is coming from a JSON instead of the database.
 *  We confirmed with the backend team the type below is what we can expect from the JSON.
 *
 * See rails/app/lib/sidebar_navigation/instructor_sidebar to understand the JSON's structure.
 */
type SidebarJSON = {
  items: {
    alwaysPresent: boolean
    /* The "kind" can be one of the following:
     * - Basic: A hyperlink. Will create a BasicLink.
     * - Section: An collection of items plus a title, for an inline container. Will create a Section.
     * - Panel: A collection of items plus a name, for a separate container. Will create a PanelLink and a Panel.
     */
    kind: string
    name: string
  } & SidebarNavList
}

export class SidebarPresenter extends present<SidebarJSON>() {
  name = () => defined(this.items).name
  alwaysPresent = () => defined(this.items).alwaysPresent
  kind = () => defined(this.items).kind
  collection = () => defined(this.items?.collection) as SidebarNavListItem[]
}
